import classNames from 'classnames';
import { AdvertComponent } from 'components/advert/advert-component.js';
import { AdvertErrorBoundary } from 'components/advert/advert-error-boundary.js';
import { shouldDisplayWithHideWhen } from 'layout/utils-hide-when.js';
import { ScreenSizeContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { AdComponent } from 'redux-state/advertisement/types';
import { IRepoState } from 'redux-state/rootReducer.js';
import { isLargeView } from 'utilities/media-queries';

export type AdSkinProps = {
  skinLeft?: AdComponent;
  skinRight?: AdComponent;
};

export const AdvertSkins = ({
  children,
  skinLeft,
  skinRight,
}: {
  children: JSX.Element;
} & AdSkinProps) => {
  const isLarge = isLargeView(useContext(ScreenSizeContext));
  const isPageLoading = useSelector((state: IRepoState) => state.LOADING.isLoading);
  const _addOverlayClass = useSelector((state: IRepoState) => state.APP.overlayOpen);
  const screenSize = useContext(ScreenSizeContext);
  const addOverlayClass = _addOverlayClass || isPageLoading;
  const display =
    shouldDisplayWithHideWhen(skinLeft?.layout, screenSize) || shouldDisplayWithHideWhen(skinRight?.layout, screenSize);

  /** We have already updated the skin target data so we do not want to override so we use overrideBaseTargeting={true} */
  return (
    <>
      {display && isLarge && skinLeft && (
        <div className={classNames('Skin Skin--left', { 'has-overlay': addOverlayClass })}>
          <AdvertErrorBoundary>
            <AdvertComponent {...skinLeft} key={screenSize} origin="skin-left" />
          </AdvertErrorBoundary>
        </div>
      )}

      {children}

      {display && isLarge && skinRight && (
        <div className={classNames('Skin Skin--right', { 'has-overlay': addOverlayClass })}>
          <AdvertErrorBoundary>
            <AdvertComponent {...skinRight} key={screenSize} origin="skin-right" />
          </AdvertErrorBoundary>
        </div>
      )}
    </>
  );
};
